import { MeterBarSegment } from '../../shared/components/meter-bar-segment/MeterBarSegment.js';
import { useMultiMeterBarHighlightedSegment } from '../hooks/store/selectors.js';

interface MultiMeterBarChartSegmentProps {
  segmentId: string;
  segmentIndex: number;
  segmentColor: string;
  segmentWidth: number;
  previousSegmentsWidth: number;
}

export const MultiMeterBarChartSegment = (
  props: MultiMeterBarChartSegmentProps,
) => {
  const {
    previousSegmentsWidth,
    segmentColor,
    segmentWidth,
    segmentId,
    segmentIndex,
  } = props;
  const highlightedSegment = useMultiMeterBarHighlightedSegment();
  const highlightedSegmentId = highlightedSegment?.id;
  const isHighlighted =
    !highlightedSegment || highlightedSegmentId === segmentId;

  return (
    <g data-segment-index={segmentIndex}>
      <MeterBarSegment
        color={segmentColor}
        width={segmentWidth}
        highlighted={isHighlighted}
        start={previousSegmentsWidth}
      />
    </g>
  );
};

MultiMeterBarChartSegment['displayName'] = 'MultiMeterBarChartSegment';
